import { Injectable } from '@angular/core';
import { Result } from '../../shared/result';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { CommonModel } from 'src/app/shared/common-model';
// import { AuthGuard } from 'src/app/authentication/guards/auth-guard.service';

@Injectable({
  providedIn: 'root'
})
export class ViewRoutesService {
  getLan: any;
  obj = new CommonModel;

  constructor(private http: HttpClient) {

    this.obj.lan = LocalstorageService.getLanguage('language');
    this.getLan = LocalstorageService.getLanguage('language');
   }

  public GetAllRoutes() {
    // let headers;
    // headers = this.AuthGuardService.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/ListofRoutes/GetRoutes`, this.obj);
  }
  public GetRouteDetails(routeid) {

    //return this,this.http.get<Result>(`${environment.apiUrl}/ListofRoutes/SearchByRoutes?RoutesIDs=` + routeid +`&lan=` + this.getLan);
    return this,this.http.get<Result>(`${environment.apiUrl}/ListofRoutes/SearchByRoutes_V1?check=1&RoutesIDs=` + routeid +`&lan=` + this.getLan);
  }

  public GetRunningTrips(routeid) {

    return this,this.http.get<Result>(`${environment.apiUrl}/ListofRoutes/SearchByRoutes_V1?check=2&RoutesIDs=` + routeid +`&lan=` + this.getLan);
  }

  public GetTripDetails(tripid) {
    return this.http.get<Result>(`${environment.apiUrl}/SearchByLocation/GetTripDetails?tripid=` + tripid  +`&lan=` + this.getLan);

  }
}

